export default __webpack_public_path__ + "static/media/gruppe.88990e66.png";